import { filter } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { getAuth } from '~ngrx/features/feature-auth/feature-auth.selectors';
import {getDetailsScopes, Paths} from '~core/security/auth.roles';
import {JwtHelperService} from '@auth0/angular-jwt';

@Component({
  selector: 'app-nao-autorizado',
  templateUrl: './nao-autorizado.component.html',
  styleUrls: ['./nao-autorizado.component.scss'],
})
export class NaoAutorizadoComponent implements OnInit {

  defaultPage!: string;
  constructor(
    private route: Router,
    private store: Store,
    public jwt: JwtHelperService
    ) { }

  ngOnInit(): void {
    this.store.pipe(
      select(getAuth)
    ).pipe(filter(a => !!a?.token))
    .subscribe(({roles, tokenRules}) => {
      if (this.jwt.isTokenExpired(tokenRules || '')) {
        return this.defaultPage = Paths.LOGIN;
      }
      const {scopes} = getDetailsScopes(this.jwt, tokenRules || '');
      return this.defaultPage = roles.map(role => scopes[role]?.defaultPage)[0] || Paths.LOGIN;
    });
  }

  irParaHome(): void{
    this.route.navigateByUrl('/' + this.defaultPage).then();
  }
}
